import { createContext, useContext } from "react";

export const LangContext = createContext({ lang: "it" });
export const useLang = () => useContext(LangContext);
